import { z } from "zod";
import { PROSPECT_STATUSES, FOLLOWUP_KINDS } from "./enums.js";
/** Admin API request contracts (validated server-side in the adminApi Lambda). */
export const statusUpdateSchema = z.object({
    status: z.enum(PROSPECT_STATUSES),
});
export const followupSchema = z.object({
    kind: z.enum(FOLLOWUP_KINDS),
    note: z.string().trim().max(2000).optional().default(""),
});
/** Per-course editable auto-email. Body is sanitized server-side before save. */
export const emailTemplateSchema = z.object({
    subject: z
        .string()
        .trim()
        .min(1, "Subject is required")
        .max(200)
        .regex(/^[^\r\n]*$/, "Subject can't contain line breaks"),
    bodyHtml: z.string().min(1, "Body is required").max(20000),
});
/** Per-course editable settings shown in the auto-email (Courses table). Both are
 * free-text; blank clears the value (Next start then falls back to the prospect's
 * selected month). */
export const courseConfigSchema = z.object({
    fee: z.string().trim().max(60).regex(/^[^\r\n]*$/, "No line breaks").default(""),
    nextStart: z.string().trim().max(60).regex(/^[^\r\n]*$/, "No line breaks").default(""),
});
/** Register a freshly uploaded brochure version (after the presigned PUT). */
export const brochureRegisterSchema = z.object({
    s3Key: z.string().min(1).max(512),
    fileName: z.string().trim().min(1).max(255),
    sizeBytes: z.number().int().positive().max(10 * 1024 * 1024),
});
export const MAX_BROCHURE_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=admin.js.map